export interface IStep2Validation {
    dashRegistration: boolean,
    dirty: boolean
}
